import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import styled from 'styled-components';
import { getMessage } from './MESSAGE';
import { devices } from 'signup-constants/styles/viewports.styles';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { getStepConfig } from '../views/getStepConfig';
import { useSelector } from 'react-redux';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { useIsFramedCentredModalStep } from '../hooks/useIsFramedCerntredModalStep';
import { H4 } from 'foundations-components/transitional/components/H4';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledBaseMessageCaption = styled.div.withConfig({
  displayName: "BaseMessageCaption__StyledBaseMessageCaption"
})(({
  $isPostAccountCreationStep,
  theme
}) => {
  if ($isPostAccountCreationStep) {
    return {
      borderTop: `3px solid ${theme.color['border-core-pressed']}`,
      paddingTop: theme.space['700'],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      [`@media ${devices.tablet}`]: {
        borderWidth: theme.borderWidth['0'],
        borderStyle: 'none',
        paddingTop: theme.space['0']
      }
    };
  } else {
    return {
      textAlign: 'center'
    };
  }
});
const Caption = styled.div.withConfig({
  displayName: "BaseMessageCaption__Caption"
})(({
  theme
}) => {
  return {
    textAlign: 'center',
    marginBottom: theme.space['1100'],
    maxWidth: '90%',
    lineHeight: theme.typography['heading-500'].lineHeight,
    [`span:not(.checked-list-icon)`]: {
      fontSize: theme.typography['heading-500'].fontSize,
      fontWeight: theme.typography['display-100'].fontWeight
    },
    [`@media ${devices.tablet}`]: {
      order: 2,
      marginTop: theme.space['600'],
      marginBottom: theme.space['0']
    }
  };
});
const StyledChildContainer = styled.div.withConfig({
  displayName: "BaseMessageCaption__StyledChildContainer"
})(({
  isPostAccountCreationStep,
  hasMessagingAboveContentInLayoutTemplate,
  isFramedCentredModalStep,
  topMargin
}) => {
  let result = {};
  if (!isPostAccountCreationStep) {
    result = Object.assign({}, result, {
      [`@media ${devices.desktop}`]: {
        height: '140px',
        top: `${topMargin}px`,
        position: 'relative'
      }
    });
  }
  if (hasMessagingAboveContentInLayoutTemplate) {
    result = Object.assign({}, result, {
      [`@media ${devices.tablet}`]: {
        height: '140px',
        top: `${topMargin}px`,
        position: 'relative'
      }
    });
  }
  if (isFramedCentredModalStep) {
    result = Object.assign({}, result, {
      [`@media ${devices.desktop}`]: {
        left: '75px',
        width: '300px'
      }
    });
  }
  return result;
});
export const BaseMessageCaption = ({
  children,
  messageKey
}) => {
  const {
    captionImage,
    captionImageHeight,
    topMargin
  } = getMessage(messageKey);
  const hasTitle = isValidI18nKey(`message.${messageKey}.title`);
  const hasSubtitle = isValidI18nKey(`message.${messageKey}.subtitle`);
  const {
    currentStep
  } = useCurrentStep();
  const stepConfig = getStepConfig(currentStep);
  const postAccountCreation = useSelector(getPostAccountCreationSteps);
  const isPostAccountCreationStep = postAccountCreation.includes(currentStep);
  const showMessagingAboveContent = stepConfig ? stepConfig.showMessagingAboveContent : false;
  const {
    isFramedCentredModalStep
  } = useIsFramedCentredModalStep();
  return /*#__PURE__*/_jsxs(StyledBaseMessageCaption, {
    $isPostAccountCreationStep: isPostAccountCreationStep,
    children: [(hasTitle || hasSubtitle) && /*#__PURE__*/_jsxs(Caption, {
      children: [hasTitle && /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `message.${messageKey}.title`
        })
      }), hasSubtitle && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `message.${messageKey}.subtitle`,
        options: {
          captionImage,
          captionImageHeight
        }
      })]
    }), /*#__PURE__*/_jsx(StyledChildContainer, {
      hasMessagingAboveContentInLayoutTemplate: showMessagingAboveContent,
      isFramedCentredModalStep: isFramedCentredModalStep,
      isPostAccountCreationStep: isPostAccountCreationStep,
      topMargin: topMargin,
      children: children
    })]
  });
};